import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "alerts" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Alertas", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  class: "search",
  for: "search-doc"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "alerts"
}
const _hoisted_9 = {
  key: 1,
  class: "no-options full"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "173",
  viewBox: "0 0 173 173",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M151.952 61.8477V111.152C151.952 119.226 147.627 126.723 140.635 130.832L97.8176 155.556C90.8256 159.593 82.1754 159.593 75.1112 155.556L32.2937 130.832C25.3016 126.795 20.9766 119.298 20.9766 111.152V61.8477C20.9766 53.7744 25.3016 46.2774 32.2937 42.1687L75.1112 17.4441C82.1033 13.4075 90.7535 13.4075 97.8176 17.4441L140.635 42.1687C147.627 46.2774 151.952 53.7023 151.952 61.8477Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M86.5 99.1146C83.5446 99.1146 81.0938 96.6638 81.0938 93.7084V55.8646C81.0938 52.9092 83.5446 50.4584 86.5 50.4584C89.4554 50.4584 91.9062 52.9092 91.9062 55.8646V93.7084C91.9062 96.6638 89.4554 99.1146 86.5 99.1146Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M86.4993 124.344C85.5623 124.344 84.6251 124.127 83.7601 123.767C82.8231 123.406 82.1021 122.902 81.3813 122.253C80.7325 121.533 80.2282 120.74 79.7957 119.875C79.4352 119.01 79.291 118.072 79.291 117.135C79.291 115.261 80.0117 113.387 81.3813 112.017C82.1021 111.369 82.8231 110.864 83.7601 110.504C86.4272 109.35 89.5991 109.999 91.6174 112.017C92.2662 112.738 92.7705 113.459 93.1309 114.396C93.4913 115.261 93.7077 116.198 93.7077 117.135C93.7077 118.072 93.4913 119.01 93.1309 119.875C92.7705 120.74 92.2662 121.533 91.6174 122.253C90.2478 123.623 88.4456 124.344 86.4993 124.344Z",
    fill: "#292D32"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, "Não há alertas, por enquanto.", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { useAxios } from '@/api/axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import AlertModel from '@/models/AlertModel'
import { AxiosResponse } from 'axios'
import { computed, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsView',
  setup(__props) {

const axios = useAxios()
const alerts = ref<AlertModel[]>([]);
const searchQuery = ref('');
const searchQueryInput = ref('');

const filteredAlerts = computed(() => {
  return alerts.value.filter(al =>
    al.title.toLowerCase().includes(searchQuery.value.toLowerCase()) || !searchQuery.value
  );
});

function getAlerts () {
  axios.get('/api/alerts').then((res: AxiosResponse<AlertModel[]>) => {
    alerts.value = res.data
  })
}

function applySearch() {
  searchQuery.value = searchQueryInput.value;
}

onMounted(() => {
  getAlerts()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("label", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        autocomplete: "off",
        type: "text",
        placeholder: "Digite sua busca",
        id: "search-doc",
        name: "search-doc",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQueryInput).value = $event)),
        onKeyup: _withKeys(applySearch, ["enter"])
      }, null, 544), [
        [_vModelText, searchQueryInput.value]
      ]),
      (_openBlock(), _createElementBlock("svg", {
        onClick: applySearch,
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none"
      }, _hoisted_7))
    ]),
    (filteredAlerts.value && filteredAlerts.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAlerts.value, (alert) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert",
              key: alert.id
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", null, _toDisplayString(alert.title), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(alert.description), 1)
            ]))
          }), 128))
        ]))
      : (filteredAlerts.value && !filteredAlerts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 }))
  ]))
}
}

})